/*
 * 版权声明
 * 上海万位数字技术有限公司（以下简称“本公司”）对其自行研究开发、编写编制的软件程序、代码等（以下简称“研发资料”）均受《中华人民共和国反不正当竞争法》、《中华人民共和国著作权法》、《中华人民共和国专利法》及适用之国际公约中有关著作权、专利权及/或其他财产所有权法律的保护，为本公司专属或持有。
 * 使用者将本公司专属或持有的研发资料用于商业、营利、广告性目的时，需事先征得本公司书面特别授权，并注明出处“上海万位数字技术有限公司”，并按照有关国际公约及中华人民共和国法律的有关规定，向本公司支付使用费。
 * 未经本公司事先明确的书面特别授权，任何单位或个人不得以任何形式、任何途径，通过任何渠道变更、篡改、发行、发布、散布、复制、重制、展示或利用研发资料全部或部分内容，否则以侵权论，依法追究法律责任。
 *
 * Copyright Notice
 * All the software programs and codes among others (hereinafter referred to as the R&D data) solely developed and written by Shanghai Wanway Digital Technology Co., Ltd. (hereinafter referred to as the Company) are protected by the Law of the People's Republic of China against Unfair Competition, Copyright Law of the People's Republic of China, Patent Law of the People's Republic of China and provisions on laws of copyrights, patent rights and/or other property ownership in international conventions that apply and exclusive to or owned by the Company.
 * While using the R&D data exclusive to or possessed by the Company for any commercial, marketing, or advertising purpose, users need ask for special authorization from the Company in writing beforehand, note the source "Shanghai Wanway Digital Technology Co., Ltd." and pay the Company royalties subject to relevant provisions in related international conventions and laws of the People's Republic of China.
 * With no prior and express written special authorization from the Company, any unit or individual shall not alter, tamper, issue, release, distribute, duplicate, remake, produce or use part or all of the R&D data in any form and any way, otherwise it shall be deemed as infringement and subject to legal penalties by law.
 */

import React, {forwardRef, useImperativeHandle, useState, useEffect} from 'react'
import {Modal} from 'antd'
import moment from 'moment';
import {WWMethods,WWUtils} from "@/tools";
import {LeafletMap} from "@ww/leaflet-component";

moment.locale('zh-cn');
let leafletMap,fence;
function FenceInfoModal(props, ref) {
    const [visible, setVisible] = useState(false);
    const [fenceId, setFenceId] = useState('');
    const [mapType, setMapType] = useState(1);
    const [fenceName, setFenceName] = useState('');

    useEffect(function () {
        // showModal(16,868035043124405,1703084969)
    },[])

    useImperativeHandle(ref, () => ({
        showModal: (id,imei,alarmTime) => {
            showModal(id,imei,alarmTime);

        }
    }));

    function showModal(id,imei,alarmTime) {
        setVisible(true);
        setFenceId(id);
        let mapType = WWUtils.getInitMapType();
        setTimeout(function () {
            initMap(mapType)
        })
        let coordinate = WWUtils.getMapTypeCoordinate(mapType)
        WWMethods.getFenceAlarmDetail(id,imei,alarmTime,coordinate,(data)=>{
            handleFenceInfo(data);
        })
    }

    function hideModal() {
        setVisible(false);
    }

    function handleFenceInfo(data) {
        let lng = data.setting.split(' ')[0];
        let lat = data.setting.split(' ')[1];
        let meter = data.setting.split(' ')[2];
        setFenceName(data.fenceName)
        let zoom;
        if (meter < 100) {
            zoom = 19;
        } else if (meter >= 100 && meter < 150) {
            zoom = 18;
        } else if (meter >= 150 && meter < 300) {
            zoom = 17;
        } else if (meter >= 300 && meter < 600) {
            zoom = 16;
        } else if (meter >= 600 && meter < 1500) {
            zoom = 15;
        } else if (meter >= 1500 && meter < 3000) {
            zoom = 14;
        } else if (meter >= 3000 && meter < 6000) {
            zoom = 13;
        } else if (meter >= 6000 && meter < 10000) {
            zoom = 12;
        } else if (meter >= 10000 && meter < 20000) {
            zoom = 11;
        } else if (meter >= 20000 && meter < 30000) {
            zoom = 11;
        } else if (meter >= 30000 && meter < 60000) {
            zoom = 10;
        } else if (meter >= 60000 && meter < 150000) {
            zoom = 9;
        } else if (meter >= 150000 && meter < 300000) {
            zoom = 8;
        } else if (meter >= 300000 && meter < 600000) {
            zoom = 7;
        } else if (meter >= 600000 && meter < 1500000) {
            zoom = 6;
        } else if (meter >= 1500000 && meter < 3000000) {
            zoom = 5;
        } else if (meter >= 3000000 && meter < 6000000) {
            zoom = 4;
        } else if (meter >= 6000000 && meter < 7500000) {
            zoom = 3;
        } else if (meter >= 7500000 && meter < 15000000) {
            zoom = 2;
        } else if (meter >= 15000000 && meter < 30000000) {
            zoom = 1;
        } else {
            zoom = 1;
        }
        if (data.type == 2) {
            setTimeout(() => {
                if (fence) {
                    fence.remove();
                }
                fence = leafletMap.showCircle(lat, lng, meter);
                leafletMap.setCenter(LeafletMap.getLatLng(lat, lng), zoom);
            }, 50);
        } else {
            setTimeout(() => {
                if (fence) {
                    fence.remove();
                }
                let list = [];
                data.setting.split(',').map(item => {
                    if(item){
                        let lng = Number(item.split(' ')[0]);
                        let lat = Number(item.split(' ')[1]);
                        list.push(LeafletMap.getLatLng(lat, lng))
                    }

                });
                fence = leafletMap.showPolygon(list);
                leafletMap.setBestView(list)
            }, 50);
        }
        if(data.histories && data.histories.length) {
            let arrs = data.histories.map(function (i) {
                return {
                    lat:i[9],
                    lng:i[10]
                }
            })
            leafletMap.showFenceRoute(arrs)
        }
    }


    function initMap(mapType) {
        setMapType(mapType)
        leafletMap = new LeafletMap('fence_map', mapType);
        leafletMap.addZoomControl(); //添加Zoom控件
    }


    return <Modal transitionName="" maskTransitionName="" visible={visible}
                  width={600}
                  onCancel={hideModal}
                  footer={null}
                  maskClosable={false}
                  destroyOnClose={true}
                  className={"default_modal"}
                  title={fenceName}>
        <div id="fence_map" style={{ height: '534px', width: '100%' }}/>
    </Modal>
}

export default forwardRef(FenceInfoModal)
